<template>
	<div class="flex flex-col h-full">
		<div class="flex-auto overflow-scroll">
			<div class="pt-4 px-4 mb-4">
				<div class="flex content-center">
					<div @click="utils.goBack(router, admin ? '/admin/recibos' : `/proveedor/${route.params.proveedor_id}/recibos`)" class="pr-2 flex items-center cursor-pointer"> 				
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
							<path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
						</svg>
					</div>	
					<h3 v-if="recibo" class="text-2xl font-bold">
						Recibo {{recibo.mes}}/{{recibo.año}}
					</h3>
				</div>	
			</div>

			<div v-if="admin && recibo && !recibo.pago" class="mb-4 px-4">
				<button class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4" @click="marcarPagado()">
					Marcar pagado
				</button>
			</div>

			<div class="mb-4 px-4">
				<div v-if="admin && recibo && !recibo.factura" class="mt-4">
					<label class="whitespace-nowrap cursor-pointer inline-block w-full border border-primary hover:bg-primary-dark text-white bg-primary font-bold text-center px-4 py-2 rounded" :for="1">Subir factura</label>
					<input
					class="hidden"
					type="file"
					:id="1"
					accept="application/pdf, .zip, .xml"
					@change="uploadFactura($event)"		
					/>
				</div>
			</div>

			<div v-if="recibo" class="w-full text-left p-4 pt-0">
				<div class="border boder-gray-300 rounded bg-white">
					<div class="overflow-scroll">
						<table class="w-full text-sm text-left ">
							<thead class="text-s border-b border-b-gray-200">														
								<th scope="col" class="py-3 px-6">
									Almacén
								</th>	
								<th scope="col" class="py-3 px-6">
									Envíos
								</th>				
								<th scope="col" class="py-3 px-6">
									Extras
								</th>					
								<th scope="col" class="py-3 px-6">
									Total (c/IVA)
								</th>
								<th scope="col" class="py-3 px-6">
									Pago
								</th>
								<th scope="col" class="py-3 px-6">
									Factura
								</th>						
							</thead>
							<tbody>
								<tr class="text-s">		
									<td class="py-3 px-6">							
										${{Math.round(recibo.almacen * 100)/100}}
									</td>
									<td class="py-3 px-6">							
										${{Math.round(recibo.envios * 100)/100}}
									</td>						
									<td class="py-3 px-6">							
										${{Math.round(recibo.extras * 100)/100}}
									</td>			
									<td class="py-3 px-6">							
										${{Math.round((recibo.envios + recibo.almacen + recibo.extras) * 1.16 * 100)/100}}
									</td>	
									<td class="py-3 px-6">							
										{{recibo.pago ? "Pagado" : "Pendiente"}}
									</td>
									<td v-if="recibo.factura" class="py-3 px-6">							
										<a :href="recibo.factura" target="_blank">
											Descargar
										</a>
									</td>	
									<td v-if="!recibo.factura" class="py-3 px-6">							
										Pendiente
									</td>															
								</tr>              
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<label class="block text-gray-700 text-sm font-bold pl-4">
				Envíos
			</label>

			<empty v-if="envios && envios.length == 0" :texto="'No hubo entregas'"> </empty>

			<div v-if="envios && envios.length > 0" class="w-full text-left p-4 ">
				<div class="border boder-gray-300 rounded bg-white overflow-hidden">
					<div class="overflow-scroll">
						<table class="w-full text-sm text-left ">
							<thead class="text-s border-b border-b-gray-200">						
								<th scope="col" class="py-3 px-6">
									Pedido
								</th>
								<th scope="col" class="py-3 px-6">
									Fecha
								</th>	
								<th scope="col" class="py-3 px-6">
									Distancia
								</th>					
								<th scope="col" class="py-3 px-6">
									Costo
								</th>				
								<th scope="col" class="py-3 px-6">
									Extra
								</th>
								<th v-if="canEditEnvios" scope="col" class="py-3 px-6">
									Acciones
								</th>
							</thead>
							<tbody>
								<tr class="text-s border-b" v-for="envio in envios" v-bind:key="envio.id">
									<td class="py-3 px-6 underline">								
										<router-link :to="`/proveedor/${route.params.proveedor_id || recibo.proveedor}/orden/${envio.pedido.id}`">
											{{envio.pedido.id}}
										</router-link> 										
									</td>
									<td class="py-3 px-6">							
										{{envio.created_at ? (new Date(envio.created_at)).toLocaleDateString("en-GB", { timeZone: 'America/Mexico_City' }) : ""}}
									</td>
									<td class="py-2 px-6 whitespace-nowrap">
										<div v-if="envio.editing" class="flex items-center gap-2">
											<input
												v-model="envio.draftDistanceKm"
												type="number"
												min="0"
												step="0.001"
												class="w-20 h-7 border border-gray-300 rounded py-0 px-2 disabled:opacity-50"
												:disabled="envio.recalculating"
											/>
											<span>km</span>
										</div>
										<span v-else>{{formatDistance(envio.distancia)}}</span>
									</td>						
									<td class="py-2 px-6 whitespace-nowrap">
										<div v-if="envio.editing" class="flex items-center gap-1">
											<span>$</span>
											<input
												v-model="envio.draftCost"
												type="number"
												min="0"
												step="0.01"
												class="w-20 h-7 border border-gray-300 rounded py-0 px-2 disabled:opacity-50"
												:disabled="envio.recalculating"
											/>
										</div>
										<span v-else>${{Math.round( (envio.costo) * 100) / 100}}</span>
									</td>
									<td class="py-3 px-6">
										${{Math.round( (envio.cargo_extra || 0) * 100) / 100}}
									</td>
									<td v-if="canEditEnvios" class="py-2 px-6">
										<div class="flex items-center gap-2">
											<template v-if="envio.editing">
												<button
													type="button"
													class="p-1 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50"
													:disabled="envio.saving || envio.recalculating"
													title="Cancelar"
													aria-label="Cancelar edición"
													@click="cancelEdit(envio)"
												>
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
														<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
													</svg>
												</button>
												<button
													type="button"
													class="p-1 rounded bg-primary text-white hover:bg-primary-dark disabled:opacity-50"
													:disabled="envio.saving || envio.recalculating"
													title="Guardar"
													aria-label="Guardar cambios"
													@click="saveEnvio(envio)"
												>
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
														<path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
													</svg>
												</button>
											</template>
											<button
												v-else
												type="button"
												class="p-1 rounded border border-gray-300 hover:bg-gray-100"
												title="Editar"
												aria-label="Editar envío"
												@click="beginEdit(envio)"
											>
												<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
													<path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931ZM16.862 4.487 19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
												</svg>
											</button>
											<button
												type="button"
												class="p-1 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-50"
												:disabled="envio.saving || envio.recalculating"
												title="Recalcular con Google"
												aria-label="Recalcular envío con Google"
												@click="recalculateEnvio(envio)"
											>
												<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4" :class="{ 'animate-spin': envio.recalculating }">
													<path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992V4.356M2.985 19.644v-4.992h4.992m12.038-5.304A9 9 0 0 0 5.638 5.638L2.985 8.292m18.03 7.416-2.653 2.654A9 9 0 0 1 3.985 14.652" />
												</svg>
											</button>
										</div>
									</td>
								</tr>              
							</tbody>
							<tfoot class="">
								<tr>
									<th scope="col" class="py-3 px-6">
										Total
									</th>
									<th scope="col" class="py-3 px-6">
										{{envios.length}}
									</th>	
									<th scope="col" class="py-3 px-6">
										{{Math.round((envios.map( e => {return (e.distancia)} ).reduce((a, b) => a + b)/1000) * 100) / 100 }} km
									</th>					
									<th scope="col" class="py-3 px-6">
										${{Math.round(envios.map( e => {return e.costo} ).reduce((a, b) => a + b) * 100) / 100 }}
									</th>
									<th scope="col" class="py-3 px-6">
										${{Math.round(envios.map( e => {return (e.cargo_extra || 0)} ).reduce((a, b) => a + b) * 100) / 100 }}
									</th>
									<th v-if="canEditEnvios" scope="col" class="py-3 px-6"></th>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
			</div>

			<label class="block text-gray-700 text-sm font-bold pl-4">
				Recolecciones
			</label>

			<empty v-if="recolecciones && recolecciones.length == 0" :texto="'No hubo recolecciones'"> </empty>

			<div v-if="recolecciones && recolecciones.length > 0" class="w-full text-left p-4">
				<div class="border boder-gray-300 rounded bg-white overflow-hidden">
					<div class="overflow-scroll">
						<table class="w-full text-sm text-left">
							<thead class="text-s border-b border-b-gray-200">
								<th scope="col" class="py-3 px-6">Recolección</th>
								<th scope="col" class="py-3 px-6">Fecha solicitada</th>
								<th scope="col" class="py-3 px-6">Distancia</th>
								<th scope="col" class="py-3 px-6">Distancia facturable</th>
								<th scope="col" class="py-3 px-6">Órdenes</th>
								<th scope="col" class="py-3 px-6">Costo</th>
							</thead>
							<tbody>
								<tr class="text-s border-b" v-for="recoleccion in recolecciones" :key="recoleccion.id">
									<td class="py-3 px-6 underline">
										<router-link :to="admin ? `/admin/recolecciones/${recoleccion.id}` : `/proveedor/${route.params.proveedor_id}/recolecciones/${recoleccion.id}`">
											#{{recoleccion.id}}
										</router-link>
									</td>
									<td class="py-3 px-6">{{formatDate(recoleccion.solicitada_at)}}</td>
									<td class="py-3 px-6">{{formatDistance(recoleccion.distancia)}}</td>
									<td class="py-3 px-6">{{formatDistance(recoleccion.distancia)}}</td>
									<td class="py-3 px-6">{{(recoleccion.recoleccion_pedidos || []).length}}</td>
									<td class="py-3 px-6">${{Math.round(recoleccion.costo * 100) / 100}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { useRoute, useRouter } from 'vue-router'
	import { supabase } from "../supabase.js"
	import { computed, onMounted, ref } from "vue"
	import { utils } from './utils/utils.js'
	import axios from "axios"
	import { useLoading } from 'vue-loading-overlay'
	import { useToast } from 'vue-toast-notification'

	export default {		
		setup() {
			const route = useRoute()
			const router = useRouter()
			const envios = ref(null)	
			const recolecciones = ref(null)
			const paymentMethods = ref([])		
			const paymentMethod = ref("")
			const recibo = ref(null)
			const admin = ref(route.name == "Admin_Recibo")
			const toast = useToast()
			const canEditEnvios = computed(() => {
				if (!admin.value || !recibo.value) return false
				return recibo.value.pago == null
			})

			const loading = useLoading({
				color: "#428b74",
				loader: "spinner"
			});

			async function getEnvios() {
				let { data, error } = await supabase
				.from("envios")
				.select('id, distancia, costo, cargo_extra, created_at, pedido(id, cliente(nombre))')       
				.order('created_at', { ascending: true })
				.eq("recibo", route.params.recibo_id)				

				if (data) {              
					return data
				} else if (error) { 
					console.log("getEnvios", error)       
					throw error 
				}   
			} 

			async function getRecolecciones() {
				return utils.getRecoleccionesRecibo(
					route.params.recibo_id,
					route.params.proveedor_id || null
				)
			}

			function beginEdit(envio) {
				envio.draftDistanceKm = Number((Number(envio.distancia || 0) / 1000).toFixed(3))
				envio.draftCost = Number(envio.costo || 0)
				envio.editing = true
			}

			function cancelEdit(envio) {
				envio.editing = false
				envio.draftDistanceKm = undefined
				envio.draftCost = undefined
			}

			async function recalculateEnvio(envio) {
				if (!envio.editing) beginEdit(envio)
				envio.recalculating = true
				try {
					const preview = await utils.previewReciboEnvio(envio.id)
					envio.draftDistanceKm = Number(preview.distancia) / 1000
					envio.draftCost = Number(preview.costo)
				} catch (error) {
					toast.error(error.message, { position: "top-right" })
				} finally {
					envio.recalculating = false
				}
			}

			async function saveEnvio(envio) {
				const distanceKm = Number(envio.draftDistanceKm)
				const cost = Number(envio.draftCost)
				if (!Number.isFinite(distanceKm) || distanceKm < 0 || !Number.isFinite(cost) || cost < 0) {
					toast.error("Ingresa una distancia y un costo válidos", { position: "top-right" })
					return
				}

				envio.saving = true
				try {
					const result = await utils.updateReciboEnvio(envio.id, {
						distancia: Math.round(distanceKm * 1000),
						costo: cost,
					})
					envio.distancia = result.envio.distancia
					envio.costo = result.envio.costo
					recibo.value = { ...recibo.value, ...result.recibo }
					cancelEdit(envio)
					toast.success("Envío actualizado", { position: "top-right" })
				} catch (error) {
					toast.error(error.message, { position: "top-right" })
				} finally {
					envio.saving = false
				}
			}

			onMounted( async () => {
				const [receiptData, deliveries, collections] = await Promise.all([
					utils.getRecibo(route.params.recibo_id),
					getEnvios(),
					getRecolecciones(),
				])
				recibo.value = receiptData
				envios.value = deliveries
				recolecciones.value = collections
			})	

			async function cobrar() {
				let loader = loading.show()

				try {
					const res = await axios.post(`/api/cobrar`, {
						recibo_id: recibo.value.id,
						proveedor_id:recibo.value.proveedor,
						payment_method: paymentMethod.value.id
					})	

					console.log(res)

					if (res.status == 200) {
						utils.updateRecibo(recibo.value.id, {pago: res.data.id})
						loader.hide()
						recibo.value.pago = res.data.id				
					} else {
						loader.hide()
						alert('Hubo un error, pregúntale a Noah')
					}						
				} catch(e) {
					loader.hide()
					alert('Hubo un error, pregúntale a Noah')
				}				
			}

			function marcarPagado() {
				if(confirm("¿Quieres marcar este recibo cómo pagado?")) {		
					let loader = loading.show()
					utils.updateRecibo(recibo.value.id, {pago: "pago manual"})
					.then( () => {
						recibo.value.pago = "pago manual"
						loader.hide()
					}) 
				}
			}

			async function uploadFactura(evt) {
				let loader = loading.show()

				uploadFile(evt)
				.then( fileName => {					
					return getURL(fileName)
				})
				.then( url => {										
					utils.updateRecibo(recibo.value.id, {factura: url})
					.then( () => {
						recibo.value.factura = url
						loader.hide()
					}) 
				})	
				.catch( error => {
					console.log(error)
					loader.hide()
					alert("Hubo un error, favor de intentarlo otra vez.")
				})			
			}

			async function uploadFile(evt) {									
				if (!evt.target.files || evt.target.files.length === 0) {
					throw new Error("Selecciona un archivo")
				}
				const file = evt.target.files[0]
				const fileExt = file.name.split(".").pop()
				const fileName = `${Math.random()}.${fileExt}`
				const filePath = `${fileName}`					

				return await utils.uploadFile('foto', filePath, file)						
			}

			async function getURL(file) {	
				console.log(file)
				let fileOnly = file.split('foto/')[1]
				return await utils.getURL('foto', fileOnly)				
			}	

			function formatDate(value) {
				return value ? new Date(value).toLocaleDateString("en-GB", { timeZone: "America/Mexico_City" }) : ""
			}

			function formatDistance(value) {
				return value == null ? "—" : `${Math.round((Number(value) / 1000) * 100) / 100} km`
			}

			return {
				route,
				envios,	
				recolecciones,
				recibo,
				router,
				utils,
				paymentMethod,
				paymentMethods,
				admin,
				canEditEnvios,
				cobrar,
				marcarPagado,
				uploadFactura,
				formatDate,
				formatDistance,
				beginEdit,
				cancelEdit,
				recalculateEnvio,
				saveEnvio
			}
		}
	}
</script>
